import { cn } from '@/lib/utils';
import { DESIGN_TOKENS } from '@/lib/design/theme';
import { Platform, TextInput, type TextInputProps } from 'react-native';

function Textarea({
  className,
  multiline = true,
  numberOfLines = Platform.select({ web: 2, native: 8 }), // On web, numberOfLines also determines initial height. On native, it determines the maximum height.
  placeholderClassName,
  ...props
}: TextInputProps & React.RefAttributes<TextInput>) {
  return (
    <TextInput
      {...props}
      className={cn(
        'border-input bg-surface-raised font-body text-foreground flex min-h-16 w-full flex-row rounded-md border px-3 py-2 text-base shadow-sm shadow-black/5 dark:bg-input/30 md:text-sm',
        Platform.select({
          web: 'placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive field-sizing-content resize-y outline-none transition-[color,box-shadow] focus-visible:ring-[3px] disabled:cursor-not-allowed',
        }),
        props.editable === false && 'opacity-50',
        className
      )}
      placeholderClassName={cn('text-muted-foreground', placeholderClassName)}
      placeholderTextColor={props.placeholderTextColor ?? DESIGN_TOKENS.colors.textMuted}
      selectionColor={props.selectionColor ?? DESIGN_TOKENS.colors.accent}
      multiline={multiline}
      numberOfLines={numberOfLines}
      textAlignVertical="top"
      style={props.style}
    />
  );
}

export { Textarea };
